export const selectTranslationSections = (state) => state.sections;
export const selectTranslationLoading = (state) => state.loading;
const selectTranslations = (state) => state.translations;
export const selectTranslationsData = (state) => selectTranslations(state)?.data;
export const selectTranslationsTotal = (state) => selectTranslations(state)?.total;
export const selectTranslationsByKey = (state) => state.translationsByKey;
export const selectTranslationIsDataChanged = (state) => state.isDataChanged;
export const selectTranslatedLanguages = (state) => state.languages;
export const selectTranslatedLanguagesLoading = (state) => state.translatedLanguagesLoading;
